import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Box, Popover } from "@material-ui/core";
import { useI18N } from "../../../common/common";

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: "none",
    },
    accesibilityItemsList: {
        listStyleType: "disc",
        margin: theme.spacing(2, 0, 0, 0),
        paddingLeft: theme.spacing(2),
    },
}));

const ApartmentAccessibilityPopover = ({
    anchorEl,
    onClose,
    apartmentCategoryAccessibilityItems,
    ...props
}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const open = Boolean(anchorEl);

    return (
        <Popover
            id="accessibility-popover"
            className={classes.popover}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            onClose={handleClose}
            disableRestoreFocus
            {...props}
        >
            <Box p={1}>
                <Typography variant="subtitle1">
                    {i18n("view.resort.accessibility.accessible_apartment")}
                </Typography>

                <Typography
                    variant="body2"
                >
                    {i18n("view.resort.accessibility.people_with_restricted_mobility")}
                </Typography>

                {apartmentCategoryAccessibilityItems?.length > 0 && (
                    <ul className={classes.accesibilityItemsList}>
                        {apartmentCategoryAccessibilityItems.map(item => {
                            return (
                                <li key={item.title}>
                                    <Typography variant="body2">
                                        {item.title}
                                    </Typography>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </Box>
        </Popover>
    );
};

ApartmentAccessibilityPopover.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func,
    apartmentCategoryAccessibilityItems: PropTypes.array,
};

export default ApartmentAccessibilityPopover;
